import { createStore, type StoreApi } from 'zustand';

import type { Permission } from '../types/Permission';

export type PermissionsState = {
    permissions: Permission[] | null;
};

export type PermissionsActions = {
    updatePermissions: (permissions: PermissionsState['permissions']) => void;
    resetStore: () => void;
};

export type PermissionsStore = PermissionsState & PermissionsActions;

export const initialState: PermissionsState = {
    permissions: null,
};

export function createPermissionsStore(userPermissionsState: PermissionsState = initialState): StoreApi<PermissionsStore> {
    return createStore<PermissionsStore>()((set) => ({
        ...userPermissionsState,
        updatePermissions: (permissions): void => {
            set(() => ({ permissions }));
        },
        resetStore: (): void => {
            set(initialState);
        },
    }));
}

